import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'addQuotes'
})
export class AddQuotesPipe implements PipeTransform {

  transform(value: string): string {
    if (value) {
      const quote = '“';
      if (!value.includes(quote)) {
        value = quote.concat(value).concat(quote);
      }
      return value;
    }
    return null;
  }

}
